import React from "react";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import {dateDDMMYYDataTableTemplate} from "../../utils/formatters/Date";
import Divider from "@material-ui/core/Divider";

const CorporateActionView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{
                       paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%',
                       overflow: 'auto'
                   }}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Administración \ Ejercicio de Derechos"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'right'}}>
                        <Button type="button" iconPos="left" label="Buscar"
                                style={{marginRight: '.5em'}}
                                onClick={props.getDataCorporateActions}/>
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12}>
                        <div style={{textAlign: 'right'}}>
                            <Button type="button" iconPos="left" label="Detalle"
                                    onClick={props.redirectDetailScreen}
                                    style={{marginRight: '.5em'}}
                                    className="p-button-secondary"/>
                            <Button type="button" iconPos="left"
                                    label="Enviar Correo" style={{marginRight: '.5em'}}
                                    onClick={props.sendEmailCorporateAction}
                                    className="p-button-secondary"/>
                        </div>
                    </Grid>


                    <Grid item xs={12}>
                        <div className="content-section implementation">
                            <DataTable
                                value={props.corporateActions}
                                responsive={true}
                                resizableColumns={true}
                                columnResizeMode={"fit"}>
                                <Column field="apply" header="Aplicado"
                                        body={props.formatApplyTemplate}
                                        style={{textAlign: 'center', width: '5%'}}
                                        sortable={true}
                                />
                                <Column field="infoDate" header="Fecha"
                                        body={dateDDMMYYDataTableTemplate}
                                        sortable={true}
                                        style={{width: '10%', textAlign: 'left'}}
                                />
                                <Column field="corporateAction" header="Ejercicio"
                                        sortable={true}
                                        style={{width: '15%', textAlign: 'left'}}
                                />
                                <Column field="fullInstrument" header="Emisora"
                                        sortable={true}
                                        style={{width: '10%', textAlign: 'left'}}
                                />
                                <Column field="registerDate" header="Fecha Registro"
                                        body={dateDDMMYYDataTableTemplate}
                                        sortable={true}
                                        style={{width: '10%', textAlign: 'left'}}
                                />
                                <Column field="exCouponDate" header="Fecha Excupón"
                                        body={dateDDMMYYDataTableTemplate}
                                        sortable={true}
                                        style={{width: '10%', textAlign: 'left'}}
                                />
                                <Column field="paymentDate" header="Fecha Pago"
                                        body={dateDDMMYYDataTableTemplate}
                                        sortable={true}
                                        style={{width: '10%', textAlign: 'left'}}
                                />
                                <Column field="descrCorporateAction" header="Descripción"
                                        style={{width: '20%', textAlign: 'left'}}
                                        sortable={true}
                                />
                                <Column header="Acciones"
                                        body={props.corporateActionTemplate}
                                        style={{textAlign: 'center', width: '10%'}}
                                />
                            </DataTable>
                        </div>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default CorporateActionView;